module.exports = __webpack_public_path__ + "img/icon-download.91192feb.svg";